module.exports = __webpack_public_path__ + "img/home-1.a73cdca7.png";